import React from 'react';
import { useField, FieldHookConfig } from 'formik';
import { CheckboxField, CheckboxFieldProps } from '@bw/foundry';

const FormikCheckboxField = (props: CheckboxFieldProps) => {
  const [field] = useField(props as FieldHookConfig<CheckboxFieldProps>);
  return <CheckboxField checked={!!field.value} {...field} {...props} />;
};

export default FormikCheckboxField;
